/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetServerSideProps } from 'next';
import { mockModel } from '../mocks/mockModel';
import operationSignatures from './_constants/operationSignatures.json';
import { PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { usePageView } from '@marriott/mi-martech-components/hooks';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function PageRenderer(props: any) {
  usePageView(props);
  return <PageRendererComponent {...props} />;
}

const defaultRendererProps = async () => {
  return {
    operationSignatures,
    sessionData: mockModel,
    sessionHeader: '',
  };
};

// SSR Render
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerSideProps: GetServerSideProps<any> = prePageCall(defaultRendererProps);

export default PageRenderer;
